import { ILocaleConfig } from "@/config/locale.config";
import { LocaleToLabelMap, SupportedLocale } from "@/enums/locale.enum";

// Greece-specific locale configuration
const greeceLocaleConfig: ILocaleConfig = {
  supportedLocales: [
    SupportedLocale.EL,
    SupportedLocale.EN,
    SupportedLocale.RU,
  ],
  defaultLocale: SupportedLocale.EL,
  languageTabs: [
    {
      key: SupportedLocale.EL,
      label: LocaleToLabelMap.get(SupportedLocale.EL)!,
    },
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
  ],
};

export default greeceLocaleConfig;
